<template>
  <section>
    <div class="box">
      <div class="box-title">
        <h3>TRELLO</h3>
      </div>
      <div class="box-content">
        <p>
          Configure suas informações de acesso ao trello.
        </p>
        <form>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>Api Key</label>
              <input class="input" type="text" v-model="newTrello.api_key" />
            </div>
            <div class="item flex-1">
              <label>Token</label>
              <input class="input" type="text" v-model="newTrello.token" />
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>Board Id</label>
              <input class="input" type="text" v-model="newTrello.board_id" />
            </div>
            <div class="item flex-1">
              <label>List Id</label>
              <input class="input" type="text" v-model="newTrello.list_id" />
            </div>
          </div>
          <div class="flex margin-top-l column">
            <div class="button primary" @click="addTag()">Adicionar</div>
            <div class="flex margin-top-l w100">
              <ul class="w100">
                <li v-for="(t, index) in newTrello.tags" :key="index" class="flex w100 item margin-top-s">
                  <div class="flex margin-top-l middle w100">
                    <div class="item flex-1">
                      <label>Tag Name</label>
                      <input class="input" type="text" v-model="t.tag_name" />
                    </div>
                    <div class="item flex-1">
                      <label>List Id</label>
                      <input class="input" type="text" v-model="t.list_id" />
                    </div>
                    <div class="button secondary" @click="removeTag(index)">Remover</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class="">
              <div class="button primary" @click="saveTrello()">
                Salvar
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

import {
  saveIntegration,
  getIntegrations,
} from "@/services/integration";

const emptyTag = {
  'tag_name': '',
  'border_id': null,
  'list_id': null,
}
export default {
  name: "Trello",
  data() {
    return {
      newTrello: {
        api_key: '',
        token: '',
        board_id: '',
        list_id: '',
        tags: []
      }
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  mounted() {
    this.getIntegrations();
  },
  methods: {
    addTag() {
      this.newTrello.tags.push(emptyTag)
    },
    removeTag(index) {
      this.newTrello.tags.splice(index, 1)
    },
    saveTrello() {
      let data = {
        api_key: this.newTrello.api_key,
        token: this.newTrello.token,
        board_id: this.newTrello.board_id,
        list_id: this.newTrello.list_id,
        tags: []
      };

      if (!data.board_id || !data.list_id || !data.api_key || !data.token) {
        this.$toast.error({
          title: "Erro",
          message: "Você precisa preencher os campos para salvar a integração!",
        });
      }

      let params = {
        trello: data
      };

      saveIntegration(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Integração salva com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao tentar salvar integração",
          });
        });
    },
    getIntegrations() {
      getIntegrations()
        .then((result) => {
          this.newTrello = result.trello;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar integrações",
          });
        });
    },

  },
};
</script>
